import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	create: {
		id: 'native-issue-table.create-child-button.create',
		defaultMessage: 'Create child item',
		description: 'Tooltip label for the button next to the issue type cell to create a child issue',
	},
});
